import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"

import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    buttonId?: string
    hideModal: () => void
    isActionHidden?: boolean
    isModalShown: boolean
    modalId?: string
    showModal: (event: React.MouseEvent) => void
    tooltip?: string
    targetElement?: Element
}

export default class ContextMenu extends React.Component<Props> {
    refAction: React.RefObject<HTMLButtonElement>

    static defaultProps: Partial<Props> = {
        tooltip: "",
        modalId: "contextMenuModal",
        buttonId: "contextMenuButton",
        isActionHidden: false,
    }

    constructor(props: Props) {
        super(props)
        this.refAction = React.createRef()
    }

    render(): JSX.Element {
        const {
            buttonId,
            children,
            hideModal,
            isActionHidden,
            isModalShown,
            modalId,
            showModal,
            tooltip,
            targetElement,
        } = this.props

        const actionClasses = `${
            isActionHidden && !isModalShown ? "is-hidden-action" : ""
        }`

        return (
            <>
                <Action
                    actionType={ActionType.icon}
                    data-ft-context-menu-button
                    data-modal={isModalShown}
                    extraClasses={actionClasses}
                    id={buttonId}
                    onClick={showModal}
                    ref={this.refAction}
                    title={tooltip}
                >
                    {Symbols.EllipsisVertical}
                </Action>

                <Modal
                    isShown={isModalShown}
                    contentProps={{
                        extraClasses: "fixed-width",
                    }}
                    containerProps={{
                        id: modalId,
                        onClose: hideModal,
                        targetRef: targetElement ? undefined : this.refAction,
                        targetElement: targetElement,
                    }}
                    innerContentProps={{
                        extraClasses: "bg-lightest",
                    }}
                >
                    {children}
                </Modal>
            </>
        )
    }
}
